export enum WorkerActions {
  START_TIMER = 'START_TIMER',
  COUNTDOWN_STARTED = 'COUNTDOWN_STARTED',
  RESET = 'RESET',
  TIMER = 'TIMER',
  HIDE_MODAL = 'HIDE_MODAL',
  LOG_OUT = 'LOG_OUT',
  CLEAR_INTERVAL = 'CLEAR_INTERVAL',
}
